import http from '@/http/service'
 


export default function Indicacoes(params={}){

    return http.get("/admin/indicacoes",{ params })

}